import { render, staticRenderFns } from "./PersonTransactionProfilePerson.vue?vue&type=template&id=323dd03c&scoped=true&"
import script from "./PersonTransactionProfilePerson.vue?vue&type=script&lang=js&"
export * from "./PersonTransactionProfilePerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323dd03c",
  null
  
)

export default component.exports